import { AxiosRequestConfig } from "axios";
import apiClient from "./apiClient";

export async function apiRequest<T = any>(
  config: AxiosRequestConfig
): Promise<T> {
  try {
    const response = await apiClient(config);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      const message =
        error.response.data?.message ||
        error.response.data?.error ||
        "Request failed";
      throw new Error(message);
    }
    if (error.request) {
      throw new Error("Network error. Please try again");
    }
    throw new Error(error.message || "Unkown error");
  }
}
